module.exports = __webpack_public_path__ + "img/hohlschnitt_koenigsblau_farbnr543.5af7d2af.jpg";